export var FieldState;
(function (FieldState) {
    FieldState["INITIAL"] = "initial";
    FieldState["IS_VALID"] = "is-valid";
    FieldState["IS_ERROR"] = "is-error";
})(FieldState || (FieldState = {}));
